/** Unified hunk header in `git diff` output. */
export const UNIFIED_HUNK_HEADER_RE = /^@@ -(\d+)(?:,(\d+))? \+(\d+)(?:,(\d+))? @@/;

export const MAX_HYDRATE_LINES_PER_GAP = 8_000;
export const MAX_HYDRATE_LINES_PER_FILE = 80_000;
export const HYDRATE_YIELD_EVERY_LINES = 512;
